import { LandingPanel } from '@features/landing/shared/ui/components/LandingPanel';
import { LandingSection } from '@features/landing/shared/ui/components/LandingSection';
import { LandingSectionSeparator } from '@features/landing/shared/ui/components/LandingSectionSeparator';
import { ParticipationChecklist } from '@features/landing/shared/ui/components/ParticipationChecklist';
import { Contacts } from '@features/landing/shared/ui/components/Contacts';
import { SummerUpcomingTournaments } from '@features/landing/summer/ui/components/SummerUpcomingTournaments';
import { LINK_SUMMER_TELEGRAM_CHANNEL } from '@features/chessrussian/customizations/constants';

const TELEGRAM_CHANNELS = [
  {
    label: <>Телеграм-чат&nbsp;›</>,
    href: LINK_SUMMER_TELEGRAM_CHANNEL,
  },
];

export function SummerTournamentsSection() {
  return (
    <LandingSection>
      <LandingPanel>
        <SummerUpcomingTournaments />
        <LandingSectionSeparator />
        <ParticipationChecklist />
        <LandingSectionSeparator />
        <Contacts telegramChannels={TELEGRAM_CHANNELS} />
      </LandingPanel>
    </LandingSection>
  );
}
